import { getQueryStrings } from "./support/browser-hacks";
import { getSignedURLsAndNamesForFiles } from "./get-files-for-app-creation";
import type { ImportTableData } from "./firebase-function-types";
import type { AIAgentCohort } from "@glide/app-description";
import { getFeatureSetting } from "./feature-settings";

export interface SetOrUpdateUsersAppParams {
    readonly prompt: string | undefined;
    readonly filesURLs: readonly ImportTableData[];
    readonly aiAgentCohort: AIAgentCohort | undefined;
}

export async function getSetOrUpdateUsersAppParams(): Promise<SetOrUpdateUsersAppParams> {
    let signedFilesURLs: readonly ImportTableData[] = [];
    const urlFiles = getQueryStrings().get("files")?.split(",") ?? [];
    if (urlFiles.length > 0) {
        signedFilesURLs = await getSignedURLsAndNamesForFiles(urlFiles);
    }
    const withAIAgent = getQueryStrings().get("withAIAgent") ?? undefined;
    let aiAgentCohort: AIAgentCohort | undefined;
    if (withAIAgent !== undefined && getFeatureSetting("obeyAIAgentCohort")) {
        aiAgentCohort = withAIAgent === "true" ? "enabled" : "disabled";
    }

    return {
        prompt: getQueryStrings().get("prompt") ?? undefined,
        filesURLs: signedFilesURLs,
        aiAgentCohort,
    };
}
